const initialState = {
  isLoading: false,
  quantities: {},
  prices: {},
  expiredFutureStartDateLineItemIds: [],
  selections: {},
  partialPaymentAmount: undefined
};
export default initialState;